import type { HTMLAttributes } from 'react';

import { cx } from './cx';

export type ChipVariant = 'default' | 'live' | 'draft' | 'err' | 'flame';

export type ChipProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: ChipVariant;
  dot?: boolean;
};

export function Chip({ variant = 'default', dot = true, className, children, ...rest }: ChipProps) {
  return (
    <span
      className={cx(
        'mf-chip',
        variant === 'live' && 'live',
        variant === 'draft' && 'draft',
        variant === 'err' && 'err',
        variant === 'flame' && 'flame',
        className,
      )}
      {...rest}
    >
      {dot && <span className="dot" />}
      {children}
    </span>
  );
}
